import {CapsuleTabs} from 'antd-mobile';
import React, {useEffect, useRef} from 'react';
import {useHomeStore} from './store';
import {Provider} from './service';
import Casino from './components/casino';
import Lottery from './components/lottery';
import './index.css';

import {goTo} from '@/utils';
import globalStore from '@/services/global.state';

const CasinoProviderTab = ({provider}: {provider: Provider}) => {
  return (
    <div className="inline-flex items-center gap-1 min-w-max">
      <img
        src={
          `/assets/images/providerIcon/${provider.name}.webp` || provider.logo
        }
        alt="provider logo"
        className="w-4 h-4 object-cover rounded flex-shrink-0"
      />
      <span className="transition-all duration-200 flex-shrink-0 whitespace-nowrap">
        {provider.name}
      </span>
    </div>
  );
};

const GameTypeTab = ({
  gameType,
  selected,
}: {
  gameType: (typeof GameTypes)[number];
  selected: boolean;
}) => {
  return (
    <div
      className={`flex flex-col items-center ${
        selected
          ? 'bg-gradient-to-b from-[#FFCAB9] to-[#FFD6B9]/0 border-t-2 border-t-c1'
          : ''
      }`}>
      <img
        src={gameType.icon}
        alt={gameType.label}
        className="w-12 h-12 object-cover rounded flex-shrink-0"
      />
      <span className="font-bold transition-all duration-200">
        {gameType.label}
      </span>
    </div>
  );
};

const GameTypes = [
  {
    icon: '/assets/images/gametypes/casino.webp',
    label: 'Casino',
    value: 'casino',
  },
  {
    icon: '/assets/images/gametypes/live.webp',
    label: 'Live',
    value: 'liveCasino',
  },
  {
    icon: '/assets/images/gametypes/lottery.webp',
    label: 'Lottery',
    value: 'lottery',
  },
  {
    icon: '/assets/images/gametypes/scratch.webp',
    label: 'Scratch',
    value: 'scratch',
  },
  {
    icon: '/assets/images/gametypes/sport.webp',
    label: 'Sports',
    value: 'sports',
  },
];

interface HomeProps {
  scrollViewRef?: React.RefObject<any>;
  scrollY?: number;
}

export default function Home({scrollViewRef, scrollY}: HomeProps) {
  const providerTabsRef = useRef<HTMLDivElement>(null);
  const {
    casinoProviders,
    getProviders,
    handleProviderChange,
    selectedProvider,
    selectedGameType,
    handleGameTypeChange,
  } = useHomeStore();

  useEffect(() => {
    if (selectedGameType === 'casino' || selectedGameType === 'liveCasino') {
      getProviders(selectedGameType);
    }
  }, [getProviders, selectedGameType]);

  const onProviderChange = (key: string) => {
    handleProviderChange(key);
  };

  const onGameTypeChange = (key: string) => {
    // if (key === 'liveCasino' || key === 'casino') {
    //   getProviders(key);
    // }
    if (key === 'scratch') {
      goTo('Scratch', {
        hideInnerTitle: '1',
      });
      return;
    }
    if (key === 'sports') {
      globalStore.openSports.next('');
      return;
    }
    handleGameTypeChange(key);
  };

  return (
    <div className="py-3 home-casino-container">
      <div className="game-type-tabs">
        <CapsuleTabs activeKey={selectedGameType} onChange={onGameTypeChange}>
          {GameTypes.map(item => (
            <CapsuleTabs.Tab
              title={
                <GameTypeTab
                  gameType={item}
                  selected={selectedGameType === item.value}
                />
              }
              key={item.value}
            />
          ))}
        </CapsuleTabs>
      </div>

      <div>
        {(selectedGameType === 'casino' ||
          selectedGameType === 'liveCasino') && (
          <>
            <div ref={providerTabsRef} className={'casino-provider-tabs py-3'}>
              <CapsuleTabs
                activeKey={selectedProvider}
                onChange={onProviderChange}>
                {casinoProviders.map(provider => (
                  <CapsuleTabs.Tab
                    title={<CasinoProviderTab provider={provider} />}
                    key={provider.id.toString()}
                  />
                ))}
              </CapsuleTabs>
            </div>
            <Casino />
          </>
        )}
        {selectedGameType === 'lottery' && (
          <Lottery scrollViewRef={scrollViewRef} scrollY={scrollY} />
        )}
      </div>
    </div>
  );
}
